// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_p84zP","sticky":"sticky_zIKou","down":"down_I1jyb"};